export const equipmentFieldForDisplayLabel: Record<string, string> = {
  license_plate: 'Placa',
  chassis_number: 'Chassi',
  renavam: 'Renavam',
  serial_number: 'Número de série',
  official_name: 'Nome',
}
